import styled from "styled-components";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export const StyledModalHeader = styled(Modal.Header)`
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  display: block;
  padding-top: 4px;
  border-bottom: none;
  padding-bottom: 1px;
  padding-top: 20px;

  .session-modal-title {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .session-modal-header {
    flex-direction: row;
    display: flex;
    align-items: center;
    padding-left: 14px;
    padding-right: 14px;
  }

  .modal-header-separator {
    width: 94%;
    height: 1px;
    margin-left: auto;
    margin-right: auto;
    border-bottom: ${({ theme }) => theme.borders.modalBorder};
    opacity: unset;
    margin-top: 18px;
    border-top: 0px;
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  display: block;
  padding-top: 4px;

  .session-content-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .session-content-subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-top: 12px;
    text-align: center;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .session-content-timer {
    margin-top: 4px;
  }

  .watch-wrapper {
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 4px;
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

export const StyledModalFooter = styled(Modal.Footer)`
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  display: block;
  padding-top: 4px;
  justify-content: center;
  border: none;
  padding: 6px 0px 24px 0px;
  display: flex;
`;

export const SessionButton = styled(Button)`
  align-self: center;
  color: ${({ theme }) => theme.colors.buttonText} !important;
  border-radius: 5px;
  background-color: transparent;
  margin-right: 1em;
  height: 42px;
  border-color: ${({ theme }) => theme.colors.buttonBorder} !important;

  :hover {
    border-color: ${({ theme }) => theme.colors.buttonBorderHighlight} !important;
  }

  :disabled {
    background-color: transparent;
    border-color: transparent !important;
  }
`;